import { $applyNodeReplacement, type LexicalNode } from "lexical";
import type { UUID } from "../../../../../utils/uuid";
import { DynamicContentToolbarNode } from "./dynamic-content-toolbar-node";
import { DynamicContentToolbarNodeMui } from "./dynamic-content-toolbar-node-mui";

export function $createDynamicContentToolbarNode(
  headless: boolean,
  segmentId: UUID,
): DynamicContentToolbarNode {
  return $applyNodeReplacement(
    new (headless ? DynamicContentToolbarNode : DynamicContentToolbarNodeMui)(segmentId, true),
  );
}

export function $isDynamicContentToolbarNode(
  node: LexicalNode | null | undefined,
): node is DynamicContentToolbarNode {
  return node instanceof DynamicContentToolbarNode;
}
